import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';


// Routings
import { AppRoutingModule } from './app-routing.module';

// Modulos Comparitos
import { SharedModule } from './shared/shared.module';
import { ServiceModule } from './services/service.module';

// interceptor
import { AuthInterceptor } from './theme/auth/auth.interceptor';

// Componentes
import { AppComponent } from './app.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AdminComponent } from './layout/admin/admin.component';
import { NopagefoundComponent } from './theme/nopagefound/nopagefound.component';
import { AuthGuard } from './services/guards/auth.guard';

import { AngularFireModule } from 'angularfire2';
import { environment } from 'src/environments/environment';

// Service
import { ToastCommunicationService } from './services/toast/toast-communication.service';

// firebaseDatabase
import { AngularFireDatabaseModule } from 'angularfire2/database';


// Toast
import { ToastyModule } from 'ng2-toasty';




@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    AdminComponent,
    NopagefoundComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    ServiceModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    ToastyModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    AuthGuard,
    ToastCommunicationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
